import { Component, computed, inject, Signal } from '@angular/core';
import { AuthService } from 'src/app/services/Auth/auth.service';
import { CurrentUser } from 'src/app/interfaces/current-user';
import { TitleCasePipe } from '@angular/common';
import { ModalsService } from 'src/app/services/Modals/modals.service';
import { Router, RouterLink } from '@angular/router';

@Component({
  selector: 'header-user-section',
  imports: [TitleCasePipe, RouterLink],
  templateUrl: './user-section.component.html',
  styleUrl: './user-section.component.scss',
})
export class UserSectionComponent {
  // injectables
  auth = inject(AuthService);
  modals = inject(ModalsService);
  router = inject(Router);

  // data
  currentUser: Signal<CurrentUser>;

  // computed
  isWithLogs = computed(() => {
    if (
      this.auth.getCurrentRole() &&
      ['ts', 'tsm', 'fae', 'approver', 'product_admin'].includes(
        this.auth.getCurrentRole()!,
      )
    ) {
      return true
    }
    return false
  });

  constructor() {
    this.currentUser = computed(() => this.auth.getCurrentUser()!);
  }

  confirmLogout() {
    this.modals
      .getInstance()
      .showConfirm(
        'Confirm Action',
        'Are you sure you want to logout?',
        'Logout',
        'Cancel',
        () => this.logout(),
      );
  }

  logout() {
    this.auth.logout().subscribe({
      next: (value) => this.redirect(),
      complete: () => this.redirect(),
    });
  }
  redirect() {
    this.router.navigate(['/']);
  }
}
